module.exports = __webpack_public_path__ + "img/download.d4e246bc.svg";